module.exports = __webpack_public_path__ + "static/img/banner6.57aa7ce.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/banner6.png
// module id = L/OU
// module chunks = 0